<template>
  <div class="entries" id="entries">
    <!-- DO NOT REMOVE WILL BREAK -->

    <div class="title">
      <h3 style="display: none;">{{ data.full_name }} {{ title }}</h3>
    </div>

    <!-- DO NOT REMOVE WILL BREAK -->
    <b-row class="title">
      <b-col cols='8' :class="{homeTitleWidget : home == true}">
        <div class="title main TournamentTitle" >
          <template v-if="home == true">
            <span class="reportWidget_title">Entries</span>
          </template>
          <!-- <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p> -->
          <template v-if="useName == 'N'">
            <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
              <template >
                <p :class="{WidgetStyle: home == true}">{{data.short_name}} <span v-if="home != true">- {{title}}</span></p>
              </template>
            </template>
            <template v-else>
              <p :class="{WidgetStyle: home == true}">{{data.short_name}}</p>
            </template>
          </template>
          <template v-else>
            <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
              <template >
                <p :class="{WidgetStyle: home == true}">{{data.full_name}} <span v-if="home != true">- {{title}}</span></p>
              </template>
            </template>
            <template v-else>
              <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p>
            </template>
          </template>
        </div>
      </b-col>
      <b-col :class="{HomeHide: home == true}" cols="4">
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
          <template v-if="config.VUE_APP_ID == 'bvt' || config.VUE_APP_TOUR == 'let' || config.VUE_APP_ID == 'sst'">
            <img class="informationImg" v-b-toggle="'collapse-1'" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/Information.png">
          </template>
          <template v-else>
            <i
              v-b-toggle="'collapse-1'"
              class="fa-solid fa-circle-info"
            ></i>
          </template>
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <div :class="{reportsHide: home == false}" class="gradHome"></div>
    <table :class="{reportsHome : home == true}">
      <thead :class="{HomeHide: home == true}" >
        <tr>
          <template v-if="tablePick === 'Entries'">
            <th>
              No
            </th>
            <th class="LeftAlign">
              Name
            </th>
            <th class="mobHide">
              <span>Nat</span>
            </th>
            <th class="representsText" v-if="data.represents_ind === 'Y'">
              Represents
            </th>
            <th class="entryStatus" v-if="home === false">
              Entry Status
            </th>
            <th class="exemptRank" v-if="home === false">
              Exempt Rank
            </th>
            <th v-if="config.VUE_APP_PLAYER_ICON === 'Y'" class=""></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template>
          <tr
            v-for="(tabledata, index) in Eds" :key="index"
            @click.stop="rowClicked(index)"
            :class="{ drawNoborder: tablePick === 'Draw', homeTr: home == true }"
          >
            <template v-if="tablePick === 'Entries' && tabledata">
              <td
                :class="{homeposnum : home == true}"
                class="posnum"
                v-if="
                  tabledata.playerno !== 'Cat' && tabledata.playerno !== 'EOF'
                "
              >
                <template v-if="home != true">
                  {{ tabledata.serial_no }}
                </template>
              </td>
                <td
                  colspan="11"
                  class="catD"
                  v-if="tabledata.playerno === 'Cat'"
                >
                  {{ tabledata.exempt_desc }}
                  <span v-if="tabledata.have_exempt_notes == 'Y' && home === false">
                    <i
                      v-b-toggle="'collapse' + index"
                      class="fa-solid fa-circle-info entriesCircle"
                    ></i>
                  </span>
                  <b-collapse v-if="home === false" :id="'collapse' + index" class="mt-2 informationCLass">
                    <div class="exemptNotes" v-html="tabledata.exempt_notes"></div>
                  </b-collapse>
                </td>
                <td
                  colspan="11"
                  class="cut"
                  v-if="tabledata.playerno === 'EOF' && home === false"
                >
                  {{ tabledata.exempt_desc }}
                  <span v-if="tabledata.have_exempt_notes == 'Y'">
                    <i
                      v-b-toggle="'collapse' + index"
                      class="fa-solid fa-circle-info entriesCircle"
                    ></i>
                  </span>
                  <b-collapse :id="'collapse' + index" class="mt-2 informationCLass">
                    <div class="exemptNotes" v-html="tabledata.exempt_notes"></div>
                  </b-collapse>
                </td>


              <td
                class="LeftAlign"
                v-if="
                  tabledata.playerno !== 'Cat' && tabledata.playerno !== 'EOF'
                "
              > 
                <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                  <template v-if="tabledata.profile == 'Y'">
                    <b-link :to="'/playerprofile/' + tabledata.playerno" class="removeUnderLineHome">
                      <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surnameuk[0].toUpperCase() + tabledata.surnameuk.slice(1).toLowerCase()}}</span>
                    </b-link>
                  </template>
                  <template v-else>
                    <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surnameuk[0].toUpperCase() + tabledata.surnameuk.slice(1).toLowerCase()}} </span>
                  </template>
                  <!-- <span v-if="tabledata.pro_ind === 'Am'"> (a)</span> -->
                </template>
                <template v-else>
                  <template v-if="tabledata.profile == 'Y'">
                    <b-link :to="'/playerprofile/' + tabledata.playerno" class="removeUnderLine">
                      {{ tabledata.name }}
                    </b-link>
                  </template>
                  <template v-else>
                    {{ tabledata.name }}
                  </template>
                </template>
                <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                <template v-if="showGender == 'Y'">
                  <template v-if="tabledata.gender == 'M'">
                    <span class="male"></span>
                  </template>
                  <template v-else>
                    <span class="female"></span>
                  </template>
                </template>
              </td>
              <td
                class="mobHide"
                :class="{mobHideRep : home == true}"
                v-if="
                  tabledata.pos !== 'CUT' &&
                    tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF'
                "
              >
                <span v-if="tabledata.nationality === ''"></span>
                <span v-else>
                  <template v-if="data.represents_flag_type === 'N'">
                    {{ tabledata.nationality }}
                  </template>
                  <template v-else>
                    <img
                      class="flag"
                      :class="{flagRep : home == true}"
                      :src="
                        (config.VUE_APP_FLAG_URL + tabledata.nationality)
                          | lowercase
                      "
                    />
                  </template>
                </span>
              </td>
              <td
                :class="{ hideRepresentsHome: home === true }"
                class="representsText"
                v-if="
                  tabledata.pos !== 'CUT' &&
                    tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    data.represents_ind === 'Y'
                "
              >
                <div class="wrap">
                  {{ tabledata.represents }}
                </div>
              </td>
              <td
                class="entryStatus"
                v-if="
                  home == false &&
                  tabledata.playerno !== 'Cat' && tabledata.playerno !== 'EOF'
                "
              >
                {{ tabledata.status_text }}
              </td>
              <td
                class="exemptRank"
                v-if="
                  home == false &&
                  tabledata.playerno !== 'Cat' && tabledata.playerno !== 'EOF'
                "
              >
                <template v-if="tabledata.exempt_rank == '0'">

                </template>
                <template v-else>
                  {{ tabledata.exempt_rank }}
                </template>
              </td>
              <td
                class=""
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
              >
                <template v-if="tabledata.profile == 'Y'">
                  <a
                    :href="'/playerprofile/' + tabledata.playerno"
                    class="playerInfoLink"
                  >
                    <span class="playerInfo">
                      <span v-if="home !== true" class="mobnone">
                        Player Info
                      </span>
                      <span v-else> </span>
                      <span class="iconRight">
                        <font-awesome-icon
                          class="icon"
                          :icon="['fa', 'chevron-right']"
                        />
                      </span>
                    </span>
                  </a>
                </template>
              </td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
// import {Information} from "@/ocs/reports/information.vue";
import Information from "@ocs-software/vue-ocs/ocs/reports/information.vue";
export default {
  name: "entries",
  props: [
    "data",
    "previousData",
    "develop",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "showGender",
    "showmore",
    "show_info_web",
    "useName"
  ],
  components: {
    Information
  },
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      win: "win"
    };
  },
  methods: {
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    }
  },
  computed: {
    tablePick: function(picked) {
      if (this.title === "Tournament Entries") picked = "Entries";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (this.title.includes("Tournament"))
          if (Array.isArray(this.data.entries.entries_entry)) {
            // reportData = this.data.entries.entries_entry;
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = this.data.entries.entries_entry.slice(0, 10);
              } else {
               reportData = this.data.entries.entries_entry; 
              }
              console.log("One");
            } else {
              reportData = this.data.entries.entries_entry;
              console.log("One");
            }
          } else {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = [this.data.entries.entries_entry].slice(0, 10);
              } else {
                reportData = [this.data.entries.entries_entry];
              }
            } else {
              reportData = [this.data.entries.entries_entry];
            }
            console.log("Two");
          }
        return reportData;
      } else {
        if (this.title === "Tournament Entries")
          if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
            if (Array.isArray(this.data.entries.entries_entry)) {
              // reportData = this.data.entries.entries_entry.slice(0, 6);
              reportData = this.data.entries.entries_entry;
              console.log("One");
            } else {
              reportData = [this.data.entries.entries_entry];
              console.log("Two");
            } 
          } else {
            if (Array.isArray(this.data.entries.entries_entry)) {
              // reportData = this.data.entries.entries_entry.slice(0, 6);
              reportData = this.data.entries.entries_entry;
              console.log("One");
            } else {
              reportData = [this.data.entries.entries_entry];
              console.log("Two");
            }
          }
        return reportData;
      }
    }
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
    Surnamelowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase();
    }
  }
};
</script>

